import { createEvent, restore, sample } from 'effector'
import { LandingItem } from '../types'
import { fx, path } from 'src/libs'
import { toPath } from '../../../../../features/router'
import { languages } from '../../../../../libs/languages'
import { RequestError } from '../../../../../shared/errorResponse'

export const setLandingForm = createEvent<LandingItem>()

export const setError = createEvent<RequestError>()

export const submitCreateLanding = createEvent<LandingItem>()

export const $landing = restore(setLandingForm, {
  lang: `${languages[0].value}`,
  title: '',
  link: '',
  isVisible: true,
})

export const createLanding = fx<LandingItem, void>({
  method: 'POST',
  url: '/partner/material/landing_page',
})

export const $error = restore(setError, {
  message: '',
  code: 0,
})

sample({
  clock: submitCreateLanding,
  fn: (landing) => {
    return {
      url: `/partner/material/landing_page`,
      body: { ...landing },
    }
  },
  target: createLanding,
})

sample({
  clock: createLanding.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setError],
})

sample({
  clock: [createLanding.doneData],
  target: toPath.prepend(path.ib.ad.landing.entry),
})
